export const getDisplayAddress = (address: string) => {
  return address.length > 11 ? `${address.slice(0, 6)}...${address.slice(-7)}` : address;
};
